<div class="flex-container-compass-ad">
    <div class="container-boxed">
        <app-sidebar [is_from_ad]="true"></app-sidebar>
        <app-mobile-header></app-mobile-header>
        <div class="progress-bar hideInMobileDiv">
            <div class="progress-step" (click)="goToStep(step.route, step.id)" [ngClass]="{'active': step.id <= actual_step}" *ngFor="let step of data_progress">
                <span class="step-label">{{step.title | translate}}</span> 
            </div>
        </div>
        <div class="progress-bar hideInDesktopDiv">
            <div class="progress-step" (click)="goToStep(step.route, step.id)" [ngClass]="{'active': step.id <= actual_step}" *ngFor="let step of data_progress; let i = index">
                <span class="step-label">{{i + 1}}</span> 
            </div>
        </div>
        <div class="container-ad-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>